import { BehaviorSubject } from 'rxjs';
import { _throw as throwError } from 'rxjs/observable/throw';
import { of } from 'rxjs/observable/of';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { BusinesLogicService } from './business-logic.service';


@Injectable()
export class HttpErrorFilter implements HttpInterceptor {

  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private _data: DataService, private _blogic: BusinesLogicService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): any {
    return next.handle(request).pipe(
      catchError((error: any) => {
        if (error.status !== 404 && error.status !== 401 && error.status !== 403 && error.status !== 422 && error.status !== 500 && error.status !== 400) {
          return of(
            this._data.redError = true
          );
        } else if ((error.status === 401 || error.status === 403)) {
            this._blogic.logout().subscribe(() => {
              localStorage.clear();
              window.location.reload();
            });
        }
        return throwError(error);
      })
    );
  }
}
